import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs';

@Injectable()
export class MarketplaceService {
  constructor(private http: HttpClient, private api: AppConfig) {
  }

  getUsers (userType, organizationId): Observable<any> {
    return this.http.get(this.api.baseUrl + '/marketplace/getUsers?type=' + userType + '&organizationId=' + organizationId,
      this.api.jsonTokenHeaders);
  }

  addMarketplace (data) {
    return this.http.post(this.api.baseUrl + '/marketplace/addMarketplace' , data , this.api.jsonTokenHeaders);
  }

  getMarketplaces (type, organizationId, countryId, cityId,
                   status, category, search, page, perPage,
                   platformId): Observable<any> {
    return this.http.get(this.api.baseUrl + '/marketplace/getMarketplaces?type=' + type + '&organizationId=' + organizationId.toString()
      + '&countryId=' + countryId + '&cityId=' + cityId.toString() + '&status=' + status
      + '&category=' + category + '&search=' + search + '&page=' + page + '&perPage=' + perPage + '&platformId=' + platformId,
      this.api.jsonTokenHeaders);
  }

  getOrganizationByCantonId (id) {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + id.toString() , this.api.jsonTokenHeaders);
  }

  getMarketplace (id) {
    return this.http.get(this.api.baseUrl + '/marketplace/getMarketplaceById?id=' + id, this.api.jsonTokenHeaders);
  }

  deleteMarketplace (id) {
    return this.http.get(this.api.baseUrl + '/marketplace/deleteMarketplace?id=' + id, this.api.jsonTokenHeaders);
  }
}
